import type { FC } from "react";

import { IconButton } from "@similarweb/ui-components";

import { UpgradeLink } from "app/components/React/Table/cells/UpgradeLink";
import { trackEvent } from "app/components/React/Table/SWReactTableTrackEvent";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { trafficSourcesSearchHrefFilter } from "app/filters/ngFilters";
import { keywordService } from "app/pages/keyword-analysis/keywordService";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const CellKeywordPhrase: FC<ITableCellProps> = ({ value, row, tableOptions }) => {
    const children = row.Children || [];
    const { isWWW, country, duration, webSource } = proNavigator.getParams();
    const keywordPageParams = {
        isWWW,
        country,
        duration,
        keyword: value,
    };
    let keywordsAnalysisDestUrl = row.url;
    const searchAdsUrl = proNavigator.href("organicsearch_keywordAnalysis_overview_2", keywordPageParams);

    const hasAllParams = isWWW && country && duration && webSource;
    if (hasAllParams) {
        keywordsAnalysisDestUrl = proNavigator.getStateUrl(
            "organicsearch_keywordAnalysis_overview_2",
            keywordPageParams,
        );
        const shouldShowMobileWeb = webSource === "MobileWeb" && keywordService.hasMobileWebSearchPermission;
        if (shouldShowMobileWeb) {
            keywordsAnalysisDestUrl = proNavigator.getStateUrl(`keywordAnalysis-mobileweb`, keywordPageParams);
        }
    }
    return value === "grid.upgrade" ? (
        <UpgradeLink hookType="keywords" />
    ) : (
        <div className="swTable-keywordCell u-relative u-full-width table-cell-buttons-container separate-text-from-buttons">
            <span className="search-keyword">
                <a
                    // @ts-ignore FIXME: strict migration - 'undefined' not assignable to 'string' — filter tolerates nullish domain/webSource via `||` fallbacks
                    href={trafficSourcesSearchHrefFilter(proNavigator)(undefined, null, [{ text: value }])}
                    className="swTable-content"
                    target="_self"
                    onClick={() => {
                        trackEvent(tableOptions, "Internal Link", value, "click");
                    }}
                >
                    {value}
                </a>
                {children.length ? <span className="u-vAlignMiddle">({row.Children.length})</span> : null}
            </span>
            <span className="link-buttons-container">
                <PlainTooltip
                    cssClass="plainTooltip-element search-keyword-cell-tooltip"
                    text="analysis.source.search.keywords.table.button.analyze"
                    placement="top"
                >
                    <a
                        href={keywordsAnalysisDestUrl}
                        target={"_blank"}
                        rel="noreferrer"
                        onClick={() => allTrackers.trackEvent("Internal link", "open", `Table/${value}/analyze`)}
                    >
                        <IconButton
                            iconName="search-keywords"
                            type="flat"
                            iconSize="xs"
                        />
                    </a>
                </PlainTooltip>
                {
                    <PlainTooltip
                        cssClass="plainTooltip-element search-keyword-cell-tooltip"
                        text="analysis.source.search.keywords.table.button.ads"
                        placement="top"
                    >
                        <a
                            href={searchAdsUrl}
                            target={"_blank"}
                            rel="noreferrer"
                            onClick={() => allTrackers.trackEvent("Internal link", "open", `Table/${value}/analyze`)}
                        >
                            <IconButton
                                iconName="search-ads"
                                type="flat"
                                iconSize="xs"
                            />
                        </a>
                    </PlainTooltip>
                }
                <PlainTooltip
                    cssClass="plainTooltip-element search-keyword-cell-tooltip"
                    text="analysis.source.search.keywords.table.button.serp"
                    placement="top"
                >
                    <a
                        href={`https://google.com/search?q=${value}`}
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => allTrackers.trackEvent("Internal link", "open", `Table/${value}/analyze`)}
                    >
                        <IconButton
                            iconName="google-search"
                            type="flat"
                            iconSize="xs"
                        />
                    </a>
                </PlainTooltip>
            </span>
        </div>
    );
};
CellKeywordPhrase.displayName = "CellKeywordPhrase";
